import React from 'react';
import { useNavigate } from 'react-router-dom';
import useWindowDimensions from '../../hooks/useWindowDimension';
import { useTranslation } from 'react-i18next';
import { ITEM_TAB_NAME, PAGE_TAB_NAME_LIST, PREFERENCE_TAB, TABLET_WIDTH } from '../../constant';
import { preferenceSaveService } from '../../services/preferenceSaveService';
import { Button } from '@chapche/ui';

const SaveNewPreferenceButton = () => {
    const { i18n } = useTranslation();
    const { width } = useWindowDimensions();
    const navigate = useNavigate();

    const saveNewPreference = () => {
        preferenceSaveService.savePreference(() => navigate(`/${PREFERENCE_TAB}/${ITEM_TAB_NAME}/${PAGE_TAB_NAME_LIST}`));
    };

    return (
        <Button type="button" className="preference__form-button" onClick={saveNewPreference}>
            {i18n.t(`app.page.preference.${width <= TABLET_WIDTH ? 'addPreferenceSmall' : 'addPreference'}`)}
        </Button>
    );
};

export default SaveNewPreferenceButton;
